// fr strings for messages/voice.ts. Same keys and {variables} as en there.
// SEO follows French searches: "voix de {name} IA", "voix IA de ...".
import type { Dict } from "../index";

const voice: Dict = {
  "voice.seo.title":
    "Voix de {name} IA : écoute-la et fais des covers | Jammable",
  "voice.seo.description":
    "Écoute des covers IA avec la voix de {name} et crée les tiennes en une minute environ. Utilise la voix IA de {name} créée par la communauté pour des chansons, de la synthèse vocale et des duos sur Jammable.",
  "voice.seo.appName": "Générateur de voix IA de {name}",
  "voice.seo.private": "Voix privée | Jammable",
  "voice.name": "Voix de {name} IA",

  "voice.removed": "Cette voix a été supprimée.",
  "voice.private": "Cette voix est privée.",
  "voice.browseOther": "Découvrir d'autres voix",

  "voice.error": "Une erreur s'est produite. Réessaie",
  "voice.copied": "Copié dans le presse-papiers !",

  "voice.newer.body":
    "{username} a mis à jour cette voix. Essaie la nouvelle version",
  "voice.newer.cta": "Nouvelle version",
  "voice.communityFavourite": "Coup de cœur de la communauté",
  "voice.uploadedBy": "Publiée par {name}",
  "voice.voices.one": "{n} voix",
  "voice.voices.other": "{n} voix",
  "voice.createCover": "Créer une cover · {uses} utilisations",
  "voice.like": "J'aime",
  "voice.unlike": "Je n'aime plus",
  "voice.comments": "Commentaires",
  "voice.saveToCollection": "Enregistrer dans une collection",
  "voice.share": "Partager la voix",
  "voice.edit": "Modifier la voix",
  "voice.report": "Signaler la voix",
  "voice.delete": "Supprimer la voix",
  "voice.more": "Plus",
  "voice.description": "Description",

  "voice.discord.label": "Parle de {name} avec la communauté",
  "voice.discord.labelNoName": "Parle de voix IA avec la communauté",
  "voice.discord.body":
    "Partage tes covers, demande de nouvelles voix et reçois des conseils sur Discord",

  "voice.similar.title": "Voix IA similaires à {name}",
  "voice.similar.sub":
    "Les utilisateurs utilisent souvent ces voix avec {name}.",
  "voice.similar.moreHub": "Plus de voix {badge}",
  "voice.popularHub.title": "Voix IA {badge} populaires",
  "voice.seeAll": "Tout voir",
  "voice.collections.title": "Collections avec {name}",
  "voice.collections.titleNoName": "Collections avec cette voix",
  "voice.pairWell.title": "Voix qui vont bien avec {name}",

  "voice.about.title": "À propos de la voix de {name} IA",
  "voice.about.use":
    "Utilise la voix IA de {name} pour créer des covers IA, comme modificateur de voix ou pour de la synthèse vocale.",
  "voice.about.categorised": "Catégories : {list}.",
  "voice.about.uses": "Cette voix a été utilisée {n} fois sur Jammable.",
  "voice.howTo.title": "Comment faire une cover IA avec la voix de {name}",

  "voice.faq.title": "FAQ sur la voix de {name} IA",
  "voice.faq.sub": "Tout pour faire des covers avec la voix de {name}.",
  "voice.link.aiCover": "Générateur de covers IA",
  "voice.link.voiceChanger": "Modificateur de voix IA",
  "voice.link.browseAll": "Voir toutes les voix IA",
  "voice.link.weights": "Alternative à Weights.gg",
  "voice.faq.how.q": "Comment faire des covers IA avec la voix de {name} ?",
  "voice.faq.how.a":
    "Pour faire des covers IA avec la voix de {name}, ajoute ton propre audio dans le studio (lis notre {dmca}). Ensuite, lance la conversion ! Ta cover IA avec la voix de {name} sera prête en 30 à 60 secondes environ.",
  "voice.faq.dmca": "politique DMCA",
  "voice.faq.input.q":
    "Quel audio puis-je utiliser pour mes covers IA avec la voix de {name} ?",
  "voice.faq.input.a":
    "Tu ne peux importer que ton propre audio original. N'utilise pas d'enregistrements contenant du contenu protégé par des droits d'auteur de tiers sans l'autorisation de leur propriétaire.",
  "voice.faq.time.q":
    "Combien de temps prend une cover IA avec la voix de {name} ?",
  "voice.faq.time.a":
    "Ta cover IA avec la voix de {name} sera prête en 30 à 60 secondes environ !",
  "voice.faq.credits.q":
    "Combien de crédits coûte une cover IA avec la voix de {name} ?",
  "voice.faq.credits.a":
    "Chaque cover IA avec la voix de {name} ne coûte qu'un crédit !",
  "voice.faq.acapella.q": "Dois-je importer un a cappella ?",
  "voice.faq.acapella.a":
    "Non, pas besoin d'importer un a cappella : notre système extrait la voix automatiquement pour ta cover IA avec la voix de {name} !",
  "voice.faq.changer.q":
    "Puis-je utiliser la voix IA de {name} comme modificateur de voix ?",
  "voice.faq.changer.a":
    "Oui. Tu peux utiliser la voix IA de {name} comme modificateur de voix ou pour de la synthèse vocale : importe ou enregistre ton audio et convertis-le avec la voix de {name} en quelques secondes.",
  "voice.faq.free.q": "La voix IA de {name} est-elle gratuite ?",
  "voice.faq.free.a":
    "Tu peux écouter les démos de la voix IA de {name} et préparer une cover gratuitement. Pour créer des covers, il faut un abonnement Jammable, qui te donne des covers IA illimitées avec la voix de {name}, des téléchargements et plus encore.",

  "voice.demos.title": "Écoute d'abord",
  "voice.demos.note":
    "Les démos sont générées automatiquement pour montrer la qualité des voix.",
  "voice.demos.maleSinging": "Chant masculin {n}",
  "voice.demos.femaleSinging": "Chant féminin {n}",
  "voice.demos.english": "Anglais",
  "voice.play": "Écouter {name}",
  "voice.pause": "Mettre {name} en pause",

  "voice.library.title": "Titres avec cette voix",
  "voice.library.sub":
    "Écoute la voix IA de {name} chanter des titres populaires de notre bibliothèque.",
  "voice.library.unknownSong": "Titre inconnu",
  "voice.library.unknownArtist": "Artiste inconnu",

  "voice.comments.count.one": "{n} commentaire",
  "voice.comments.count.other": "{n} commentaires",
  "voice.comments.add": "Ajouter un commentaire",
  "voice.comments.post": "Publier",
  "voice.comments.top": "Populaires",
  "voice.comments.newest": "Plus récents",
  "voice.comments.empty": "Aucun commentaire ici...",
  "voice.comments.emptySub": "Lance la conversation !",
  "voice.comments.more": "Afficher plus de commentaires",
  "voice.comments.posted": "Commentaire publié !",
  "voice.comments.avatarAlt": "Avatar de l'utilisateur",
  "voice.comments.creator": "Créateur",
  "voice.comments.pinned": "Épinglé",
  "voice.comments.reply": "Répondre",
  "voice.comments.replyLabel": "Réponse au commentaire",
  "voice.comments.replyPlaceholder": "T'en penses quoi ?!",
  "voice.comments.viewReply.one": "Voir {n} réponse",
  "voice.comments.viewReply.other": "Voir {n} réponses",
  "voice.comments.viewMore": "Voir {n} de plus",
  "voice.comments.justNow": "à l'instant",
  "voice.comments.minutes": "{n} min",
  "voice.comments.hours": "{n} h",
  "voice.comments.days": "{n} j",
  "voice.comments.repliesFailed": "Impossible de charger les réponses",
  "voice.comments.pinnedToast": "Commentaire épinglé !",
  "voice.comments.unpinnedToast": "Commentaire désépinglé !",
  "voice.comments.pinFailed": "Impossible d'épingler le commentaire",
  "voice.comments.pin": "Épingler le commentaire",
  "voice.comments.unpin": "Désépingler le commentaire",
  "voice.comments.delete": "Supprimer le commentaire",
  "voice.comments.report": "Signaler le commentaire",

  "voice.addTo.title": "Ajouter à une collection",
  "voice.addTo.error": "Erreur de chargement des collections : {message}",
  "voice.addTo.empty": "Aucune collection trouvée...",
  "voice.addTo.emptySub": "Crée ta première collection !",
  "voice.addTo.new": "Nouvelle collection",
};

export default voice;
